import { GraphApiService } from '@nuso/common/data-access-api';
import { Injectable, inject } from '@angular/core';
import {
  searchMediaPointsQuery,
  setMediaPointRecordingSettingsMutation,
  accountRecordingPreferencesQuery,
  updateAccountRecordingPreferencesMutation,
  servicesWithMediaPointsQuery,
  getIamMediaPointQuery,
  availableServicesAndAppUsersForMediaPointsQuery,
  createIamMediaPointsMutation,
  mediaPointRecordingEnabledAtSourceQuery,
} from './iam-media-point.queries';
import {
  AccountRecordingPreferences,
  RecordingMediaPoint,
  RecordingSettings,
  RecordingMediaPointObject,
  CreateMediaPointsInput,
  RecordingEnabledAtSourceStatus
} from '@nuso/recording/types';
import { SearchInput } from "@nuso/common/types";
import { PlatformServiceAbridged } from '@nuso/services/types';

@Injectable({
  providedIn: 'root',
})
export class IamMediaPointService {
  private graphApi = inject(GraphApiService);


  searchMediaPoints(input: SearchInput) {
    return this.graphApi.watchQuery<{ totalCount: number, mediaPoints: RecordingMediaPoint[] }>({
      fetchPolicy: 'network-only',
      query: searchMediaPointsQuery,
      variables: {
        input,
      },
    });
  }

  servicesWithMediaPoints() {
    return this.graphApi.watchQuery<{ services: PlatformServiceAbridged[] }>({
      fetchPolicy: 'cache-and-network',
      query: servicesWithMediaPointsQuery,
    });
  }

  availableServicesAndAppUsersForMediaPoints() {
    return this.graphApi.watchQuery<{ services: PlatformServiceAbridged[], appUsers: RecordingMediaPointObject[] }>({
      fetchPolicy: 'network-only',
      query: availableServicesAndAppUsersForMediaPointsQuery,
    });
  }

  accountRecordingPreferences(id: string) {
    return this.graphApi.watchQuery<any>({
      fetchPolicy: 'network-only',
      query: accountRecordingPreferencesQuery,
      variables: {
        id
      },
    });
  }

  mediaPointRecordingEnabledAtSource(id: string) {
    return this.graphApi.watchQuery<{ status: RecordingEnabledAtSourceStatus, errorMessage?: string}>({
      fetchPolicy: 'network-only',
      query: mediaPointRecordingEnabledAtSourceQuery,
      variables: {
        id,
      },
    });
  }

  setMediaPointRecordingSettings(input: RecordingSettings) {
    return this.graphApi.mutate({
      mutation: setMediaPointRecordingSettingsMutation,
      variables: {
        input,
      },
    });
  }

  updateAccountRecordingPreferences(input: AccountRecordingPreferences) {
    return this.graphApi.mutate({
      mutation:updateAccountRecordingPreferencesMutation,
      variables: {
        input,
      },
    });
  }

  getIamMediaPoint(mediaPointId: string) {
    return this.graphApi.watchQuery<RecordingMediaPoint>({
      query: getIamMediaPointQuery,
      variables: {
        input: { id: mediaPointId },
      },
    });
  }

  createIamMediaPoints(input: CreateMediaPointsInput) {
    return this.graphApi.mutate({
      mutation: createIamMediaPointsMutation,
      variables: {
        input,
      },
    });
  }
}
